/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import { RouteObject } from 'react-router-dom';
import { PaymentSuccessPage } from './navigation';
import { SidebarWidget } from '@/widgets/sidebar-widget-react';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const getAppNavService = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const getPaymentSuccessPageRoute = (props: any): RouteObject | any => {
  const srv = getAppNavService();
  const storageSrv = StorageModule?.getInstance();
  const navigate = useNavigate();
  const _handleDropDownItemClick = (item: any) => {
    console.log(`id`, item?.id);
    if (item.id === 'logout') {
      storageSrv.reset('session');
      storageSrv.reset('local');
      navigate(`/`);
    } else {
      toast.success('Coming soon!');
    }
  };

  return {
    path: '/payment-success',
    element: <PaymentSuccessPage />,
  };
};
